import NumberField from "@p-ban/common/src/components/form/NumberField/NumberField"
import useDebounce from "@p-ban/common/src/hooks/useDebounce"

import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import HELP_LINKS from "../../../../constant/helpLinks"

import img from "./sheetCnt.png"

const 実装枚数 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { sheetCnt: shouldShow } = getDisplayCondition(values)
  const onUpdateValue = useDebounce(handlers.number)
  const legend = "実装枚数"

  return (
    <OneClickField isShow={shouldShow} helpURL={HELP_LINKS.実装枚数} legend={legend} src={img}>
      <NumberField
        name={FIELD_NAMES.実装枚数}
        value={values.sheetCnt}
        onUpdateValue={onUpdateValue}
        min={1}
        max={9999}
        maxDecimalDigits={0}
        step={1}
        suffix="枚"
        error={!!errors?.sheetCnt}
        aria-label={legend}
      />
      <OneClickFieldMessages error={errors?.sheetCnt} />
    </OneClickField>
  )
}

export default 実装枚数
